interface AuthRegistrationForm {
  email: string;
  password: string;
  termsAccepted: boolean;
  fromEmail?: boolean;
}

const useAuthRegistrationForm = (token?: string, initialValues?: Partial<AuthRegistrationForm>) => {
  const { defineField, errors, handleSubmit, setErrors, setFieldError, values } = useForm<AuthRegistrationForm>({
    initialValues: {
      email: initialValues?.email || "",
      password: "",
      termsAccepted: initialValues?.termsAccepted || false,
      fromEmail: initialValues?.fromEmail || false,
    },
    validationSchema: toTypedSchema(AUTH_REGISTRATION_SCHEMA),
  });

  const fields: AuthRegistrationFields = {
    email: defineField("email"),
    password: defineField("password"),
    termsAccepted: defineField("termsAccepted"),
    fromEmail: defineField("fromEmail"),
  };

  const loading = ref(false);
  const { sendEvent } = useAnalytics();

  const submit = handleSubmit(async (formData) => {
    loading.value = true;

    // Подготавливаем данные для отправки
    const registrationData = {
      email: formData.email,
      password: formData.password,
      termsAccepted: formData.termsAccepted,
      ...(token && { token }),
      ...(formData.fromEmail && { fromEmail: true }),
    };

    const { body, success } = await useAuthRegistrationDto(registrationData);

    if (success && body.data) {
      const { setAuthToken } = useAuthStore();
      const { setRefreshTokenCookie } = useAuthToken();
      const { closeModal } = useModalStore();

      setAuthToken(body.data);
      setRefreshTokenCookie(body.data);

      sendEvent("site_sign_up_completed", {
        auth_provider_name: "email",
      });

      const { item } = await useGetClientDto();

      if (item.value) {
        const { setClient } = useClientStore();
        const { $i18n } = useNuxtApp();
        const route = useRoute();
        const queryParameters = route.query;

        setClient(item.value);
        loading.value = false;
        if (!token) {
          closeModal();
        }

        if (queryParameters[SHARED_URL_QUERY_PARAMETERS.RedirectTo]) {
          await navigateTo(queryParameters[SHARED_URL_QUERY_PARAMETERS.RedirectTo] as string, {
            external: true,
          });

          return;
        }

        await navigateTo("/" + $i18n.locale.value + "/client/projects");
      }
    }

    if (!success) {
      setErrorsFields.rest(setErrors, body);
    }

    loading.value = false;
  });

  return {
    errors,
    fields,
    handleSubmit: submit,
    loading,
    setFieldError,
    values,
  };
};

export { useAuthRegistrationForm };
